/**
 * Accommodations Panel with Level filter
 * This is used on butler/concierge/togethernest landing pages from
 * the all inclusive section
 * Why did I make a separate component for this you ask? Why not ?
 * 🤷‍♂️
 */

// deps
import Fetchling from '~/js/modules/fetchling';
import PropTypes from 'prop-types';
import AccommodationCard from '~/js/components/accommodations/AccommodationCard';
import Modal from '~/js/components/global/Modal';
import FeatureTooltips from '~/js/components/accommodations/FeatureTooltips';
import ReactLoader from '~/js/components/global/ReactLoader';

// internals
const internals = {};
const { Component, Fragment } = React;
const GoFetch = new Fetchling();

internals.roomDetailURI = {
  butler: '/all-inclusive/butler-service/',
  concierge: '/all-inclusive/concierge-service/',
  together: '/all-inclusive/accommodations/together-nest/'
};

export default class MainPanel extends Component {
  static propTypes = {
    level: PropTypes.string.isRequired,
    resortList: PropTypes.array
  };

  static defaultProps = {
    level: '',
    resortList: []
  };

  constructor(props) {
    super(props);

    this.resortDDL = React.createRef();

    this.state = {
      rooms: [],
      filteredRooms: [],
      resort: {},
      isListView: false,
      modalTitle: '',
      modalDetails: '',
      status: 'loading'
    };
  }

  componentDidMount() {
    const { _updateStatus } = this;

    GoFetch.post('/fetchRoomData/', null, {})
      .then(response => {
        const { status = 'error', data = {} } = response;

        if (status === 'success') {
          const resorts = Object.keys(data.roomData);
          const allRooms = resorts.reduce((acc, rstCode) => [...acc, ...data.roomData[rstCode]], []);

          if (this.props.level.length > 0) {
            const rooms = this._filterRoomsBy(allRooms);

            this._updateRooms(rooms, _updateStatus('success'));

            return 0;

          }

          this._updateRooms(allRooms, _updateStatus('success'));
        } else {

          _updateStatus('error');
        }

        return 0;
      });

    window.addEventListener('resize', _.debounce(() => {

      if (window.innerWidth < 768 && this.state.isListView) {
        this.setState({ isListView: false });
      }
    }, 200));
  }

  _updateRooms = (rooms, cb) => this.setState({ rooms }, cb);

  _updateStatus = (status) => this.setState({ status });

  _updateModal = (modalTitle = '', modalDetails = '') => () => this.setState({ modalTitle, modalDetails });

  _filterRoomsBy = (rooms = []) => {
    const { level = '' } = this.props;

    if (level === 'butler') {
      return rooms.filter((room) => room.butler);
    }

    if (level === 'concierge') {
      return rooms.filter((room) => room.concierge);
    }

    if (level === 'together nest') {
      return rooms.filter((room) => room.loveNest);
    }

    return rooms.filter((room) => room.butler);
  }

  _updateView = (isListView = false) => () => this.setState({ isListView });

  _updateSelectedResort = () => {
    const resort = {};
    const { resortList } = this.props;

    resort.code = this.resortDDL.current.value;
    (this.resortDDL.current.value === '') ? resort.name = '' : resort.name = resortList.find((rstObj) => rstObj.code === this.resortDDL.current.value).shortName;
    const filteredRooms = this._filterRoomsByResort(this.state.rooms, resort.code);

    this.setState({ resort, filteredRooms });
  }

  _filterRoomsByResort = (rooms = [], resortCode) => rooms.filter((room) => room.resortCode === resortCode);

  render() {
    const modalId = 'mdl-promotion';
    const { isListView, resort = {}, status, modalTitle, modalDetails, filteredRooms = [] } = this.state;
    const { name: resortName = '' } = resort;
    const { level = '', resortList = [] } = this.props;
    const resortOptions = resortList.map((rstObj) => (<option key={rstObj.code} value={rstObj.code}>{rstObj.shortName}</option>));

    return (
      <Fragment>
        {
          {
            error: (<span className="txt-center display-block">An error has occurred, please refresh this page and try again.</span>),
            loading: (<ReactLoader className="sk-loader-accommodation-level"/>),
            success: (<Fragment>
              <div className="bg-gradient">
                <div className="container">
                  <div className="row center-xs">
                    {
                      (level === 'together nest') ? <Fragment>
                        <div className="xs-12 together-nest-available-top">
                          <i className="icon-logo-together-nest" />
                          <h3 className="together-nest-available-top-title">Available at:</h3>
                        </div>
                      </Fragment> : <Fragment>
                        <div className={`xs-12 accommodation-ttl big nunito-extra-bold color-blue ${(level === 'concierge') ? 'concierge' : ''}`}>
                          {`${level} suites`}
                          <span className="color-373737 pr">are available at:</span>
                        </div>
                      </Fragment>
                    }
                    <div className="xs-12 lg-8 xxl-5">
                      <div className="control-wrapper custom-ddl">
                        <select name="resort" id="resort" ref={this.resortDDL} onChange={ this._updateSelectedResort }>
                          <option selected disabled value="">Select Resort</option>
                          {
                            resortOptions
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-eee padding-top-3-5rem">
                <div className="container">
                  <div className="row center-xs">
                    <div className="xs-12 txt-left pr">
                      {
                        resort.code && <Fragment>
                          <h3 className="accommodation-ttl no-pad capitalize inline-block color-blue">
                            {`${filteredRooms.length} ${level} rooms`}
                            <span className="opensans-semibold uppercase no-pad">
                              {`at ${resortName}`}
                            </span>
                          </h3>
                          <div className="inline-block grid-view txt-center pa hidden-xs">
                            <div onClick={ this._updateView() } className="change-view color-acacac">
                              <i className={`icon-grid-view ${ (!isListView) ? 'color-blue' : '' }`} />
                              <span className="display-block opensans-semibold color-373737">GRID VIEW</span>
                            </div>
                          </div>
                          <div className="inline-block list-view txt-center pa hidden-xs">
                            <div onClick={ this._updateView(true) } className="change-view color-acacac">
                              <i className={`icon-list-view ${ (isListView) ? 'color-blue' : '' }`} />
                              <span className="display-block opensans-semibold color-373737">LIST VIEW</span>
                            </div>
                          </div>
                        </Fragment>
                      }
                    </div>
                    <div className="tooltip_templates hide">
                      <FeatureTooltips />
                    </div>
                    {
                      resort.code ? filteredRooms.map((room) => <AccommodationCard key={ room.code } roomInformation={ room } isListView={ isListView } modalId={ modalId } villageCode={ (level === 'together nest' ? 'together' : level) } updateModal={ this._updateModal } roomDetailURI={ internals.roomDetailURI } includeResortParam />) : 'Please select a resort'
                    }
                    <Modal id={ modalId } title={ modalTitle } content={ modalDetails } />
                  </div>
                </div>
              </div>
            </Fragment>)
          }[status]
        }
      </Fragment>
    );
  }
}
